module.exports = __webpack_public_path__ + "img/logo.eb2428f5.png";